/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { GeneralErrorPage } from '@exo/frontend-features-insurance-chrome-ui';
import { useParams } from 'react-router-dom';
import * as S from './LoginErrorPage.styles';

export const LoginErrorPage = () => {
  const { error_message } = useParams() as ErrorMessage;
  const errorMessage =
    `${error_message?.charAt(0).toUpperCase()}${error_message?.slice(1)}` ?? 'Invalid request';

  return (
    <S.ErrorWrapper>
      <GeneralErrorPage graphQLError={null} error={errorMessage} useDisplayButton={false} />
    </S.ErrorWrapper>
  );
};

type ErrorMessage = {
  error_message?: string;
};
